import api from "@/api";
import { useTempStoreOptions } from "./tempOptions";
import { useDefaultStore } from ".";
import { useToastStore } from "./toast";

export const useExpenseTemp = defineStore("useExpenseTemp", () => {
	const tempStoreOpt = useTempStoreOptions();
	const store = useDefaultStore();
	const toast = useToastStore();
	const systemPermissions = store.initialStatus;

	// const canUseExpenses = systemPermissions?.can_use_expenses;
	const canUseExpenses = computed(() => systemPermissions?.can_use_expenses);
	const clientList = ref<any>([]);
	const expenseTypes = ref<any>([]);
	const vehicleTypes = ref<any>([]);
	const receiptTypes = ref<any>([]);
	const cutoffMessage = ref<string | any>("");

	async function fetchExpensesTypes() {
		// clients
		try {
			const res = await api.getLocationAndCategory(
				"locationOnCallInfo,locationSleepoverInfo",
			);
			// let locations = res.data.data.map((el) => {
			// 	return {
			// 		id: el.id,
			// 		name: el.name,
			// 	};
			// });
			// clientList.value = locations;
			clientList.value = res.data.data;
		} catch (error) {
			console.warn(error);
		}
		if (!tempStoreOpt.tempHasExpenses || !canUseExpenses.value) return;
		// if (
		// 	getExpenseTypes().length > 0 &&
		// 	getVehicleTypes().length > 0 &&
		// 	receiptTypes.value.length > 0
		// )
		// 	return;

		// console.log("Preparing expense metadata...");

		// try {
		// 	const res = await api.getTempExpensesType();
		// 	expenseTypes.value = res.data.data;
		// } catch (error) {}

		try {
			const CODES_TO_GET_RANGE = new Set(["EMCR", "EMMC", "ESUB"]);
			const res = await api.getTempExpensesType();
			const resArr = res.data.data?.children || [];
			let mileageVehicleAndEngineTypes = [];
			let receiptReasonTypes = [];
			const expenseTypesL = [];

			for (const expenseType of resArr) {
				const item: any = {
					id: expenseType.upt_id,
					code: expenseType.upt_code,
					name: expenseType.upt_name + " Expense",
				};
				if (CODES_TO_GET_RANGE.has(expenseType.upt_code)) {
					try {
						const res1 = await api.getExpenseRange(expenseType.upt_code);
						// "fetchExpenseRange",

						item.ranges = res1.data.map((el) => {
							// el.id = uuidv4();
							return el;
						});

						// console.log(item.name, res1.data);
					} catch (error) {
						console.warn(error);
					}
				}
				if (expenseType.children.length) {
					item.children = [];
					for (const el of expenseType.children) {
						const child: any = {
							id: el.upt_id,
							code: el.upt_code,
							name: el.upt_name,
						};
						if (CODES_TO_GET_RANGE.has(el.upt_code)) {
							try {
								const res2 = await api.getExpenseRange(el.upt_code);
								// "fetchExpenseRange",

								// console.log(el.upt_name, res2.data);
								child.ranges = res2.data.map((el) => {
									// el.id = uuidv4();
									return el;
								});
							} catch (error) {
								console.warn(error);
							}
						}
						item.children.push(child);
					}
				}
				expenseTypesL.push(item);
				if (expenseType.upt_name === "Receipts") {
					receiptReasonTypes = expenseType.children.map((el) => {
						return {
							id: el.upt_id,
							code: el.upt_code,
							name: el.upt_name,
						};
					});
				}

				if (expenseType.upt_name === "Mileage") {
					mileageVehicleAndEngineTypes = expenseType.children.map((el) => {
						return {
							id: el.upt_id,
							code: el.upt_code,
							engineTypes: el.children.map((el) => {
								return {
									id: el.upt_id,
									code: el.upt_code,
									name: el.upt_name,
								};
							}),
							name: el.upt_name,
						};
					});
				}
			}
			// store.commit("ADD_VEHICLE_TYPES", mileageVehicleAndEngineTypes);
			vehicleTypes.value = mileageVehicleAndEngineTypes;
			// store.commit("ADD_RECEIPT_TYPES", receiptReasonTypes);
			receiptTypes.value = receiptReasonTypes;
			expenseTypes.value = expenseTypesL;
		} catch (error) {
			console.warn(error);
			// errors.push(error.message);
		}
	}

	async function fetchImage(id) {
		return new Promise(async (resolve, reject) => {
			try {
				const res = await api.getImage(id);
				const blob = new Blob([res.data], {
					type: res.headers["content-type"],
				});
				const r = new FileReader();
				r.addEventListener("load", () => {
					resolve(r.result);
				});
				r.readAsDataURL(blob);
			} catch (error) {
				reject(error);
			}
		});
	}

	function getExpenseTypes() {
		return expenseTypes.value;
	}
	function getVehicleTypes() {
		return vehicleTypes.value;
	}

	const vehicleTypeEnum = computed(() => {
		const obj: any = {};
		const vehicleTypes = getVehicleTypes();

		const formatTitle = (txt) => {
			if (txt == "Push Bike") return "Bicycle";
			return txt;
		};
		for (const vehicleType of vehicleTypes) {
			if (vehicleType.name === "Car")
				obj.CAR = {
					id: vehicleType.id,
					code: vehicleType.code,
					value: formatTitle(vehicleType.name),
				};
			if (vehicleType.name === "Motorcycle")
				obj.MOTORCYCLE = {
					id: vehicleType.id,
					code: vehicleType.code,
					value: formatTitle(vehicleType.name),
				};
			if (vehicleType.name === "Push Bike")
				obj.BICYCLE = {
					id: vehicleType.id,
					code: vehicleType.code,
					value: formatTitle(vehicleType.name),
				};
		}
		return obj;
	});

	function getRanges(code: any) {
		for (const item of expenseTypes.value) {
			if (item.code === code) return item.ranges;
			for (const child of item.children) {
				if (child.code === code) return child.ranges;
			}
		}
	}

	function getLabelForEngineType(item: any) {
		return `${item.from || 0}cc${item.to ? "-" + item.to + "cc" : " and over"}`;
		// return item.to
		// 	? `${item.from || 0}cc${" - " + item.to + "cc"}`
		// 	: `${item.from || 0} and over`;

		// if (item.from && item.to) {
		// 	return `${item.from || 0}cc${" - " + item.to + "cc"}`;
		// } else if (item.from) {
		// 	return `${item.from || 0} and over`;
		// }
		return "";
	}

	const expenseTypeEnum = computed(() => {
		const obj: any = {};
		for (const element of getExpenseTypes()) {
			if (element.name === "Mileage Expense") {
				obj[element.id] = element.name;
				obj["MILEAGE"] = element.name;
			}
			if (element.name === "Subsistence Expense") {
				obj[element.id] = element.name;
				obj["SUBSISTENCE"] = element.name;
			}
			if (element.name === "Receipts Expense") {
				obj[element.id] = element.name;
				obj["RECEIPT"] = element.name;
			}
		}
		return obj;
	});

	async function checkCutoff() {
		try {
			const result = await api.checkCutoff();
			// if (result.data?.data?.before_api_1) {
			// 	cutoffMessage.value = result.data.data.before_api_1;
			// } else {
			// 	cutoffMessage.value = "";
			// }
			cutoffMessage.value = result.data?.data?.before_api_1 ?? "";
		} catch (error) {
			console.warn(error);
		}
	}

	function handleErrorPing(items: any) {
		const errArr = [];
		for (const item of Object.keys(items)) {
			if (items[item] === null) {
				errArr.push(item);
			}
		}
		if (errArr.length > 0)
			toast.openToastError(`Please fill all required fields.`);

		return errArr;
	}

	return {
		clientList,
		fetchExpensesTypes,
		expenseTypes,
		getExpenseTypes,
		vehicleTypeEnum,
		fetchImage,
		getRanges,
		getLabelForEngineType,
		expenseTypeEnum,
		cutoffMessage,
		checkCutoff,
		receiptTypes,
		handleErrorPing,
	};
});
